import axios from 'axios'
import {API_URL} from '../constants';

const BARINFO_API_URL = `${API_URL}/barInfoEntities`;

class BarInfoService {

    fetchBarInfoEntities(page, pageSize, fromDate, toDate, orderNo, pcode) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${BARINFO_API_URL}/findBy`, {page: page, pageSize: pageSize, fromDate: fromDate, toDate: toDate, orderNo: orderNo, pcode: pcode},
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    printTails(ids) {
        const token = sessionStorage.getItem('token');
        let idList = [];
        for(let i=0;i<ids.length; i++){
            idList.push(ids[i]);
        }
        let body = {
            ids : idList
        };
        return axios.post(`${BARINFO_API_URL}/printTails`, body,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }   
}

export default new BarInfoService();
